/**
 * Snaps a point on a line to a raster interval
 * @param point the point to be snapped
 * @param line the line the point is snapped on
 * @param snapInterval defines the length of a step on the line
 */
export function snapPointToRastering(
  point: paper.Point,
  line: paper.Path.Line,
  snapInterval: number
): paper.Point {
  const snapPoint = line.getNearestPoint(point)
  const startOffset = line.getOffsetOf(snapPoint)
  const endOffset = line.length - line.getOffsetOf(snapPoint)
  const rasteredStartOffset = Math.round(startOffset / snapInterval) * snapInterval
  const rasteredEndOffset = Math.round(endOffset / snapInterval) * snapInterval
  const startDiff = Math.abs(startOffset - rasteredStartOffset)
  const endDiff = Math.abs(endOffset - rasteredEndOffset)
  let rasteredPointOffset: number

  // threshold to not immediately snap to a line end
  const effectiveSnapInterval = snapInterval / 2

  const distanceToEnd = Math.min(rasteredEndOffset, line.length - rasteredStartOffset)
  const distanceToStart = Math.min(rasteredStartOffset, line.length - rasteredEndOffset)

  if (distanceToEnd < snapInterval) {
    if (distanceToEnd < effectiveSnapInterval) {
      rasteredPointOffset = line.length
    } else {
      rasteredPointOffset = line.length - snapInterval
    }
  } else if (distanceToStart < snapInterval) {
    if (distanceToStart < effectiveSnapInterval) {
      rasteredPointOffset = 0
    } else {
      rasteredPointOffset = snapInterval
    }
  } else if (startDiff <= endDiff) {
    rasteredPointOffset = rasteredStartOffset
  } else {
    rasteredPointOffset = Math.min(line.length - rasteredEndOffset, line.length)
  }

  return line.getPointAt(rasteredPointOffset)
}
